export const PRODUCT_SEARCH_COUNT = 10;

export const BLANK_TEMP_PRODUCT = {
  productName: "",
  manufacturerName: "",
  productModelName: "",
  purchaseDatetime: null,
};
